import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import * as uuid from 'uuid';
import { UserResponseModel } from '@auth-models/Response/UserResponseModel';
import { MessageComponent } from '@global-message/Message.component';
import { ValidationResponseModel } from '@global-models/Response/ValidationResponseModel';
import { OperationType, VbtDocumentType } from '@global-enum/GeneralUtility';
import { ValueModel } from '@global-models/ValueModel';
import { MenuModel } from '@global-models/Response/MenuResponseModel';
import { DashboardItemResponseModel } from '@global-models/Response/DashboardItemResponseModel';
import { ParamaterGroupType } from '@global-enum/ParameterGroupType';
import { escapeHtml } from './html-escape';

/**
 * Bir değerin geçerli bir `Date` olup olmadığını döndürür.
 *
 * Daha önce RxJS'in **özel (private)** iç modül yolundan (`rxjs` paketinin `internal`
 * klasörü) import ediliyordu.
 * O yol RxJS 7'de tamamen kaldırıldığı için 21 dosyadaki import RxJS yükseltmesini
 * bloke ediyordu. Implementasyon RxJS 6.6.7 ile birebir aynıdır:
 *
 *     return value instanceof Date && !isNaN(+value);
 *
 * `Invalid Date` (örn. `new Date('abc')`) için `false` döner — çağıran kodun
 * güvendiği davranış budur.
 */
export function isDate(value: any): value is Date {
  return value instanceof Date && !isNaN(+value);
}

@Injectable()
export class AppHelper {

  constructor() { }

  public static GetDashboardUser(): UserResponseModel {
    return JSON.parse(localStorage.getItem('DashboardUser')) as UserResponseModel;
  }

  public static NewGuid(): string {
    return uuid.v4();
  }

  public static IsValidGuid(guid: String): boolean {
    var pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    if (guid.match(pattern)) {
      return true;
    } else {
      return false;
    }
  }

  public static GroupBy(collection: any[], property: string): any[] {
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});

    return Object.keys(groupedCollection).map(key => ({ key, value: groupedCollection[key] }));
  }

  public static UploadFile(data: any, filename: string, filetype: string) {
    if (data !== null) {
      const blob = new Blob([data], { type: 'application/' + filetype + ';charset=utf-8' });
      const dataUrl = 'data:application/' + filetype + ';charset=utf-8;base64,' + data;

      const datax = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = dataUrl;
      //link.download = filename + '_' + this.getNowDateFilename() + '.' + filetype;
      link.download = filename;
      link.click();

      setTimeout(function () {
        window.URL.revokeObjectURL(datax);
      });
    } else {
      Swal.fire('Uyarı !', 'Oluşturulan bir ' + filetype + ' dosyası bulunamadı.', 'warning');

    }
  }

  public static UploadFile2(data: any, filename: string, filetype: string) {
    if (data !== null) {
      const blob = new Blob([data], { type: 'application/' + filetype });
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      link.click();

      setTimeout(function () {
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    } else {
      Swal.fire('Uyarı !', 'Oluşturulan bir ' + filetype + ' dosyası bulunamadı.', 'warning');

    }
  }

  public static UploadFileName(data: any, filename: string, filetype: string) {
    if (data !== null) {
      const blob = new Blob([data], { type: 'application/' + filetype });
      const dataUrl = 'data:application/' + filetype + ';base64,' + data;

      const datax = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = filename + '.' + filetype;
      link.click();

      setTimeout(function () {
        window.URL.revokeObjectURL(datax);
      });
    } else {
      Swal.fire('Uyarı !', 'Oluşturulan bir ' + filetype + ' dosyası bulunamadı.', 'warning');
    }
  }

  public static ConvertBase64ToBlobData(base64Data: string, extension: string, sliceSize = 512) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    let contentType = this.BlobContentType(extension);
    if (this.IsNullOrEmpty(contentType)) { return null; }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public static BlobContentType(e: string): string {
    let fileType: string = '';
    if (e == 'pdf' || e == 'csv' || e == 'zip' || e == 'rar') {
      fileType = `application/${e}`;
    }
    else if (e == 'xml' || e == 'xslt') {
      fileType = 'application/xml';
    }
    else if (e == 'jpeg' || e == 'jpg' || e == 'png') {
      fileType = 'image/png';
    }
    else if (e == 'txt') {
      fileType = 'text/plain';
    }
    else if (e == 'ppt' || e == 'pot' || e == 'pps' || e == 'ppa') {
      fileType = 'application/vnd.ms-powerpoint';
    }
    else if (e == 'pptx') {
      fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
    }
    else if (e == 'doc' || e == 'dot') {
      fileType = 'application/msword';
    }
    else if (e == 'docx') {
      fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    }
    else if (e == 'xls' || e == 'xlt' || e == 'xla') {
      fileType = 'application/vnd.ms-excel';
    }
    else if (e == 'xlsx') {
      fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }

    return fileType;
  }

  public static getNowDateFilename() {
    const today = new Date();

    const dd = '0' + today.getDate();
    const mm = '0' + (today.getMonth() + 1);
    const yyyy = today.getFullYear();
    const hours = today.getHours();
    const minutes = today.getMinutes();
    const milliseconds = today.getMilliseconds();

    // tslint:disable-next-line:max-line-length
    const datetimestring = yyyy + mm.substring(mm.length, mm.length - 2) + dd.substring(dd.length, dd.length - 2) + hours + minutes + milliseconds;

    return datetimestring;
  }

  public static getCurrentDate() {
    return new Date();
  }

  public static getNowDate() {
    const today = new Date();

    const dd = '0' + today.getDate();
    const mm = '0' + (today.getMonth() + 1);
    const yyyy = today.getFullYear();
    const datetimestring = yyyy + '-' + mm.substring(mm.length, mm.length - 2) + '-' + dd.substring(dd.length, dd.length - 2);

    return datetimestring;
  }

  public static getDateFormat(today: Date) {

    const dd = '0' + today.getDate();
    const mm = '0' + (today.getMonth() + 1);
    const yyyy = today.getFullYear();

    const datetimestring = yyyy + '-' + mm.substring(mm.length, mm.length - 2) + '-' + dd.substring(dd.length, dd.length - 2);

    return datetimestring;
  }

  public static getDateDifference(firstDate, secondDate): number {
    var _firstDate: any = new Date(firstDate);
    var _secondDate: any = new Date(secondDate);
    var dateDiff: any = Math.floor((secondDate - firstDate) / (1000 * 3600 * 24));

    return dateDiff;
  }

  public static getClearPhoneNumber(value: string) {
    let str = value.replace(/_/gi, '');
    str = str.replace('(', '');
    str = str.replace(')', '');
    str = str.replace(/ /gi, '');
    return str;
  }

  public static unpack(str) {
    const bytes = [];
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      bytes.push(char);
    }
    return bytes;
  }

  public static ThrowException(exception: HttpErrorResponse, msgVbt: MessageComponent) {
    let val = exception.error;
    if (val.ErrorCode === undefined || val.ErrorCode === null) {
      val = exception;
    }
    msgVbt.ExceptionModal('HATA !', val, false);
  }

  public static priceViewFormat(value: string): string {

    if (value === undefined || value === null) {
      return "0";
    }

    value = value.toString();
    const arrayValue = value.split('.');
    let responseValue = arrayValue[0];

    if (arrayValue[0].length > 3) {
      responseValue = "";

      let charListValue = arrayValue[0].replace(/\,/g, "").split('');

      let k = 0;
      for (let i = charListValue.length - 1; i >= 0; i--) {
        const char = charListValue[i];
        responseValue += char;
        k++;
        if (k % 3 == 0 && i > 0) {
          responseValue += ".";
          k = 0;
        }
      }

      const charListReverseValue = responseValue.split("");
      responseValue = "";
      for (let i = charListReverseValue.length - 1; i >= 0; i--) {
        const char = charListReverseValue[i];
        responseValue += char;
      }
    }

    if (arrayValue.length == 2) {
      if (arrayValue[1].length === 1) {
        responseValue += "," + arrayValue[1] + "0";
      }
      else {
        responseValue += "," + arrayValue[1].replace(/\./g, "");
      }
    }
    else {
      responseValue += ",00";
    }

    return responseValue;

  }

  public static round2Digit(numberValue: number): number {
    return Math.round(numberValue * 100) / 100;
  }

  public static priceUblFormat(value: string): number {
    if (value === undefined) {
      return 0;
    }

    const strValue = value.toString().replace(/\./g, "").replace(/\,/g, ".");
    const nbrValue = Number(strValue);

    return nbrValue;
  }

  public static MinDateControl(date: Date): boolean {
    date = new Date(date);
    if (isDate(date)) {
      if (date.getDay() === 1 && date.getMonth() === 0 && date.getFullYear() === 1) {
        return false;
      }
      else {
        return true;
      }
    }
    else {
      return false;
    }
  }

  public static IsNullOrEmpty(value: string): boolean {

    if ((value === null) || (value === undefined) || (value.length === 0)) {
      return true;
    }

    return false;
  }

  /**
   * Serbest metin alanlarında HTML/script içeriği olup olmadığını kontrol eder
   * (`<`, `>`, `javascript:`, `onerror=` gibi event handler'lar). Form kaydından önce
   * kullanıcıyı uyarmak içindir; asıl doğrulama sunucu tarafında yapılmalıdır.
   */
  public static ContainsHtml(value: string): boolean {
    if (AppHelper.IsNullOrEmpty(value)) {
      return false;
    }

    return /[<>]|javascript\s*:|\bon[a-z]+\s*=/i.test(value);
  }

  /** Dinamik değeri HTML string'e eklemeden önce encode eder. Bkz. `escapeHtml`. */
  public static EscapeHtml(value: any): string {
    return escapeHtml(value);
  }

  public static IsNullOrUndefined(value: any): boolean {
    if ((value === null) || (value === undefined)) {
      return true;
    }

    return false;
  }

  public static HasValue(value: any): boolean {

    if ((value === null) || (value === undefined)) {
      return false;
    }

    return true;
  }

  public static HasRows(value: any[]): boolean {

    if ((value === null) || (value === undefined) || (value.length === 0)) {
      return false;
    }

    return true;
  }

  public static ValidIBAN(IBAN: string): string {
    let CODE_LENGTHS = {
      AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
      CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
      FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
      HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
      LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
      MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
      RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
    };

    let iban = IBAN.toUpperCase().replace(/[^A-Z0-9]/g, ''),
      code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);

    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return "";
    }

    return iban;
  }

  public static ValidateEmail(email: string): boolean {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }

  public static SetDateTimeNow(): Date {
    const today = new Date();
    const dateWithoutTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), today.getSeconds(), 0);
    return dateWithoutTime;
  }

  public static SetDateTimeNowGTM3(date: Date): Date {
    if (!isDate(date)) { return date; }
    const dateWithoutTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    let userTimezoneOffset = dateWithoutTime.getTimezoneOffset() * 60000;
    let result = new Date(dateWithoutTime.getTime() - userTimezoneOffset);
    return result;
  }

  public static DateNowControl(date: Date): boolean {
    const today = new Date();

    if (date > today) {
      return false;
    }

    return true;
  }

  public static GetDateTimeFormat() {
    return 'dd.MM.yyyy HH:mm:ss';
  }

  public static GetDateFormat() {
    return 'dd.MM.yyyy';
  }

  public static MergeArrays<T>(target: Array<T>, source: Array<T>) {

    if (this.HasRows(source)) {
      source.forEach(message => target.push(message));
    }
  }

  public static PushValidationMessage(result: Array<ValidationResponseModel>, status: OperationType, message: string) {

    var validationResponse = new ValidationResponseModel();
    validationResponse.Status = status;
    validationResponse.Message = message;
    result.push(validationResponse);
  }

  public static FilterValidationMessages(messageList: Array<ValidationResponseModel>, operationList?: Array<OperationType>) {

    var filteredMessages = Array<ValidationResponseModel>();

    // Message listesi doluysa
    if (this.HasRows(messageList)) {

      // Sadece belli operatörler filtrelenmek istenirse
      if (this.HasRows(operationList)) {

        if (operationList.length == 1)
          filteredMessages = messageList.filter(p => p.Status == operationList[0]);
        else filteredMessages = messageList.filter(p => operationList.includes(p.Status));
      }
      // Tip filtresi yoksa tüm mesajları göster
      else filteredMessages = messageList
    }

    return filteredMessages;
  }

  public static DisplayWarningMessages(messageList: Array<ValidationResponseModel>) {

    var messageList = this.FilterValidationMessages(messageList, new Array<OperationType>(OperationType.Warning));
    if (this.HasRows(messageList)) {

      var warningString = '';
      messageList.forEach(element => { warningString += AppHelper.EscapeHtml(element.Message) + '<br>'; })

      if (!AppHelper.IsNullOrEmpty(warningString)) {
        Swal.fire(OperationType.Warning, warningString, 'warning');

      }
    }
  }

  public static DocumentAuthList(): Array<string> {

    const documentList = new Array<ValueModel>(
      { KEY: VbtDocumentType.OutgoingInvoice, VALUE: 'Invoice/OutgoingInvoiceListNew' },
      { KEY: VbtDocumentType.IncomingInvoice, VALUE: 'Invoice/IncomingInvoiceListNew' },
      { KEY: VbtDocumentType.EArchiveInvoice, VALUE: 'Invoice/EarchiveInvoiceListNew' },
      { KEY: VbtDocumentType.MyCustomIncomingInvoice, VALUE: 'Invoice/MyCustomIncomingInvoiceListNew' },
      { KEY: VbtDocumentType.OutgoingDespatchAdvice, VALUE: 'DespatchAdvice/OutgoingDespatchAdviceListNew' },
      { KEY: VbtDocumentType.IncomingDespatchAdvice, VALUE: 'DespatchAdvice/IncomingDespatchAdviceListNew' },
      { KEY: VbtDocumentType.MyCustomIncomingDespatchAdvice, VALUE: 'DespatchAdvice/MyCustomIncomingDespatchAdviceListNew' },
      { KEY: VbtDocumentType.OutgoingCreditNote, VALUE: 'EMM/CreditNoteListNew' },
      { KEY: VbtDocumentType.OutgoingSMM, VALUE: 'SMM/ESMMListNew' },
      { KEY: VbtDocumentType.MigratedOutgoingInvoice, VALUE: 'Migration/MigratedOutgoingInvoiceListNew' },
      { KEY: VbtDocumentType.MigratedIncomingInvoice, VALUE: 'Migration/MigratedIncomingInvoiceListNew' },
      { KEY: VbtDocumentType.OutgoingExpenseVoucher, VALUE: 'ExpenseVoucher/OutgoingExpenseVoucherListNew' },
    );

    const authDocumentList = Array<string>();

    const menuList = (JSON.parse(localStorage.getItem('DashboardMenus')) as Array<MenuModel>);
    menuList.forEach(menu => {

      for (let i = 0; i < menu.SubMenus.length; i++) {
        const subMenus = menu.SubMenus[i];

        for (let j = 0; j < documentList.length; j++) {
          const document = documentList[j];

          if (document.VALUE === subMenus.ScreenCode) {
            authDocumentList.push(document.KEY);
            break;
          }

        }
      }

    });

    return authDocumentList;
  }

  public static ApplicationAuthList(): Array<string> {
    const authApplicationList = Array<string>();

    const dashboardItemList = (JSON.parse(localStorage.getItem('DashboardItems')) as DashboardItemResponseModel);
    dashboardItemList.Applications.forEach(item => {
      authApplicationList.push(item.Code);
    });

    return authApplicationList;
  }

  public static GetParameterList(): any {

    let parameterList = new Array<string>();
    parameterList.push(ParamaterGroupType.OutgoingInvoiceStatusForUser);
    parameterList.push(ParamaterGroupType.OutgoingInvoiceStatus);
    parameterList.push(ParamaterGroupType.IncomingInvoiceStatusForUser);
    parameterList.push(ParamaterGroupType.IncomingDespatchAdviceStatusForUser);
    parameterList.push(ParamaterGroupType.OutgoingDespatchAdviceStatusForUser);
    parameterList.push(ParamaterGroupType.OutgoingSmmStatus);
    parameterList.push(ParamaterGroupType.OutgoingCreditNoteStatus);
    parameterList.push(ParamaterGroupType.EArchiveStatus);
    parameterList.push(ParamaterGroupType.InvoiceProfileTypes);
    parameterList.push(ParamaterGroupType.InvoiceTypes);
    parameterList.push(ParamaterGroupType.PrintingStatus);
    parameterList.push(ParamaterGroupType.ArchivingStatus);
    parameterList.push(ParamaterGroupType.ErpProcessStatus);
    parameterList.push(ParamaterGroupType.IsDeletedStatusCodes);
    parameterList.push(ParamaterGroupType.InWorkFlowStatus);
    parameterList.push(ParamaterGroupType.EArchiveReportStatus);
    parameterList.push(ParamaterGroupType.EArchiveMailStatus);
    parameterList.push(ParamaterGroupType.OutgoingDespatchAdviceStatus);
    parameterList.push(ParamaterGroupType.DespatchAdviceTypes);
    parameterList.push(ParamaterGroupType.DespatchAdviceProfileTypes);
    parameterList.push(ParamaterGroupType.QuantityTypes);
    parameterList.push(ParamaterGroupType.DespatchProcessStatus);
    parameterList.push(ParamaterGroupType.ExemptionReasonTypes);
    parameterList.push(ParamaterGroupType.CurrencyCode);
    parameterList.push(ParamaterGroupType.TaxTypes);
    parameterList.push(ParamaterGroupType.OdemeSekli);
    parameterList.push(ParamaterGroupType.WitholdingTaxTypes);
    parameterList.push(ParamaterGroupType.TransportModeTypes);
    parameterList.push(ParamaterGroupType.DeliveryTerms);
    parameterList.push(ParamaterGroupType.PackagingTypeCode);
    parameterList.push(ParamaterGroupType.PaymentMeansTypes);
    parameterList.push(ParamaterGroupType.AccountingTypes);
    parameterList.push(ParamaterGroupType.HKSAdditionalItem);
    parameterList.push(ParamaterGroupType.HKSCostTypes);
    parameterList.push(ParamaterGroupType.ReadingStatus);
    parameterList.push(ParamaterGroupType.IsCancelStatusCodes);
    parameterList.push(ParamaterGroupType.OutgoingBillStatus);

    parameterList.push(ParamaterGroupType.PartyType);
    parameterList.push(ParamaterGroupType.DocumentType);
    parameterList.push(ParamaterGroupType.DocumentDetailType);
    parameterList.push(ParamaterGroupType.SerialTypes);
    parameterList.push(ParamaterGroupType.EArchiveReportGibStatus);
    parameterList.push(ParamaterGroupType.MailState);
    parameterList.push(ParamaterGroupType.DocumentObjectingType);
    parameterList.push(ParamaterGroupType.TicketReportType);
    parameterList.push(ParamaterGroupType.PaymentType);
    parameterList.push(ParamaterGroupType.ServiceType);
    parameterList.push(ParamaterGroupType.SpendingTypes);
    parameterList.push(ParamaterGroupType.ExpenseVoucherTypes);
    parameterList.push(ParamaterGroupType.OutgoingExpenseVoucherStatus);
    parameterList.push(ParamaterGroupType.DomesticLicensePlateScheme);
    parameterList.push(ParamaterGroupType.ForeignLicensePlateScheme);
    parameterList.push(ParamaterGroupType.DomesticTransportEquipmentScheme);
    parameterList.push(ParamaterGroupType.ForeignTransportEquipmentScheme);
    parameterList.push(ParamaterGroupType.TechnologySupportItemSchemes);


    return { ParameterGroupNameList: parameterList };
  }

}
